import api from 'api';
import {useGetApi} from 'common/hooks/useGetApi';
// import {useHandleApiErrorCallback} from 'common/hooks/useHandleApiErrorCallback';
import {useEffect} from 'react';

export const useCheckSSO = () => {
   // const handleError = useHandleApiErrorCallback();
   const {request, state} = useGetApi(api.ssoEnabled);

   useEffect(request, [request]);

   return state;
};
